import HCLDX from "./hcldx";

class UserReverification {

    static getUserReverificationPageRouteURL() {
        return HCLDX.baseURL() + '/emea/resources/user-reverification';
      }
}

export default UserReverification;